module.exports = __webpack_public_path__ + "img/tt-default.7f581bcb.png";